/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/button-has-type */
import React, { useRef, useState } from "react";
import Popup from "reactjs-popup";
import MsxIcons from "../../Common/components/Icons/MsxIcons/MsxIcons";
import Button from "../../Common/components/Buttons/Button/Button";

const FileImportDialog = ({ files, setFiles, showImportedFiles, handleImportClick, setShowImportedFiles }) => {
  const [selectAll, setSelectAll] = useState(false);
  const fileInputRef = useRef(null);
  const [fileToReplace, setFileToReplace] = useState(null);

  const toggleSelectFile = (id) => {
    setFiles(files.map((file) => (file.id === id ? { ...file, selected: !file.selected } : file)));
  };

  const deleteFile = (id) => {
    setFiles(files.filter((file) => file.id !== id));
  };

  const handleFileChange = (event) => {
    const newFile = event.target.files[0];
    if (newFile && fileToReplace !== null) {
      setFiles(files.map((file) => (file.id === fileToReplace ? { ...file, name: newFile.name } : file)));
      setFileToReplace(null);
    }
  };

  const replaceFile = (id) => {
    setFileToReplace(id);
    fileInputRef.current.click();
  };

  const handleSelectAllChange = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    setFiles(files.map((file) => ({ ...file, selected: newSelectAll })));
  };

  return (
    <div
      onClick={(event) => {
        event.stopPropagation();
      }}
      className={`fixed top-0 left-0 right-0 bottom-0 bg-transparent z-999 ${showImportedFiles ? "" : "hidden"}`}
    >
      <Popup
        open={showImportedFiles}
        modal
        contentStyle={{ maxWidth: "500px", width: "90%" }}
        closeOnDocumentClick={false}
        closeOnEscape={false}
      >
        <div className="modal rounded-md max-h-screen overflow-y-auto bg-[#F4F4F4DB]">
          <div className="rounded-md shadow-lg bg-[#F4F4F4DB] pl-3 pr-3">
            <h3 className="text-sm flex justify-start mb-3 ml-2 pt-3 bg-[#F4F4F4DB]">
              Select the file you would like to import
            </h3>
            <div className="flex items-center space-x-2 mb-4">
              <input
                type="checkbox"
                className={`ml-2 w-5 h-5 appearance-none border-1 rounded-md cursor-pointer transition-all duration-100 ${
                  selectAll ? "bg-primary" : "bg-white"
                }`}
                checked={selectAll}
                onChange={handleSelectAllChange}
              />
              <span>File name</span>
            </div>
            {/* File List */}
            <div className="thin-scrollbar overflow-visible h-[150px]">
              <ul className="mb-3 bg-white">
                {files.map((file) => (
                  <li key={file.id} className="flex justify-between items-center mb-2  p-2 rounded-md">
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        className={`mr-2 w-5 h-5 appearance-none border-1 rounded-md cursor-pointer transition-all duration-100 ${
                          file.selected ? "bg-primary" : "bg-white"
                        }`}
                        checked={file.selected}
                        onChange={() => toggleSelectFile(file.id)}
                      />
                      <span className="break-words whitespace-normal">{file.name.trim()}</span>
                    </div>
                    <div className="flex space-x-2 items-center justify-center">
                      <MsxIcons name="action_delete" size="nano" className="text-[#0075A3]" />
                      <button className="text-[#0075A3] hover:underline" onClick={() => deleteFile(file.id)}>
                        Delete
                      </button>
                      <MsxIcons name="refresh" size="nano" className="text-[#0075A3]" />
                      <button className="text-[#0075A3] hover:underline" onClick={() => replaceFile(file.id)}>
                        Replace
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex items-end justify-end space-x-2 p-3">
              <Button
                onClick={handleImportClick}
                className="border border-[#626469] rounded-sm text-sm text-black pl-2 pr-2 pt-1 pb-1"
              >
                Import
              </Button>
              <Button
                onClick={() => {
                  setShowImportedFiles(false);
                }}
                className="border border-[#626469] rounded-sm text-sm text-black pl-2 pr-2 pt-1 pb-1"
              >
                Close
              </Button>
            </div>
          </div>
          <input type="file" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} />
        </div>
      </Popup>
    </div>
  );
};

export default FileImportDialog;
